/**
 * An array of drawdown option objects for selection in the Cashflow Modeller.
 * Each option contains a `value` used internally and a `label` for display purposes.
 *
 * @type {Array<{ value: string, label: string }>}
 * @property {string} value - The internal value representing the drawdown option.
 * @property {string} label - The user-friendly label for the drawdown option.
 *
 * Options:
 * - "Percentage %" : Represents a drawdown as a percentage.
 * - "Per annum"    : Represents a drawdown per annum.
 */
const DrawdownOptions = [
  {
    value: "Percentage %", label: "Percentage %",
    display: "",
  },
  { value: "Per annum", label: "Per Annum", display: "Pa" },
];

export default DrawdownOptions;
